"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper class provides ability to set custom axios instance
 */
class ApiBuilder {
    constructor(instance, apiUrl) {
        this.axiosInstance = instance;
        this._apiUrl = apiUrl;
    }
    /**
     * Get or create new instance of ApiBuilder
     * @param axiosInstance
     * @returns ApiBuilder
     */
    static getInstance(axiosInstance, apiUrl) {
        if (!ApiBuilder.instance) {
            ApiBuilder.instance = new ApiBuilder(axiosInstance, apiUrl);
        }
        return ApiBuilder.instance;
    }
    /**
     * Create new ApiBuilder instance
     * @param axiosInstance
     * @returns
     */
    static create(axiosInstance, apiUrl) {
        if (ApiBuilder.instance) {
            throw new Error('ApiBuilder already initialized. Use ApiBuilder.getInstance() instead');
        }
        ApiBuilder.instance = new ApiBuilder(axiosInstance, apiUrl);
        return ApiBuilder.instance;
    }
    get apiUrl() {
        return this._apiUrl;
    }
    build(clazz, configuration) {
        // eslint-disable-next-line new-cap
        return new clazz(configuration, undefined, this.axiosInstance);
    }
}
exports.default = ApiBuilder;
//# sourceMappingURL=ApiBuilder.js.map